export default __webpack_public_path__ + "images/f5f35107d6a3b4c8e7f4f66b53612670.svg";